module.exports = __webpack_public_path__ + "img/PlayShape.73af42db.png";